import { z } from 'zod';

export const BookItem = z.object({
  cover: z.string().nullish(),
});

export const GalateaWrapUpData = z.object({
  finished_stories: z.array(BookItem).optional(),
  started_stories: z.array(BookItem).optional(),
  personality: z.object({
    image: z.string(),
    text: z.string(),
    title: z.string(),
  }),
  hunk: z
    .object({
      name: z.string(),
      story_slug: z.string(),
      title: z.string(),
      cover: z.string().nullish(),
    })
    .optional(),
  top_author: z
    .object({
      name: z.string().nullish(),
      cover: z.string().nullish(),
      id: z.string().nullish(),
    })
    .optional(),
  top_characters: z
    .array(
      z.object({
        slug: z.string(),
        emoji: z.string().nullish(),
      }),
    )
    .optional(),
  top_tags: z
    .array(
      z.object({
        slug: z.string(),
        emoji: z.string().nullish(),
        percentile_rank: z.number(),
      }),
    )
    .optional(),
  authors_supported: z.number().default(0),
  total_interactions: z.number().default(0),
  total_completed_chapters: z.number().default(0),
  longest_reading_streak: z.number().default(0),
  total_reading_days: z.number().default(0),
  textbook_chapters_read_share: z.number().default(0),
  audiobook_chapters_listened_share: z.number().default(0),
  top_reader_percentile_rank: z.number(),
  month: z.string(),
});

export const ColtWrapUpResponse = z.object({
  wrap_up: GalateaWrapUpData,
});

export type GalateaWrapUpData = z.infer<typeof GalateaWrapUpData>;
export type ColtWrapUpResponse = z.infer<typeof ColtWrapUpResponse>;
